<template>
  <t-config-provider :global-config="globalConfig">
    <RouterView />
  </t-config-provider>
</template>

<script setup lang="ts">
import { getTDesignLocale } from './settings/globalConfig'

// 全局特性配置，引入英文语言配置包 enConfig
const globalConfig = getTDesignLocale()

// const click = () => {
//   // 成功关闭弹窗
//   if (window.electron.ipcRenderer) window.electron.ipcRenderer.send('close')
// }
</script>
